function toggleStoreDetails(button) {
    const wrapper = button.closest('.store-variant-detail').querySelector('.store-details-wrapper');
    
    if (wrapper.classList.contains('open')) {
        wrapper.style.height = '0';
    } else {
        wrapper.style.height = `${wrapper.scrollHeight}px`;
    }
    
    wrapper.classList.toggle('open');
    button.classList.toggle('open');
}